import './App.css';
import Main from './pages/Main';
import { BrowserRouter as Router } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './pages/Login';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { ProgressSpinner } from 'primereact/progressspinner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        {/* <OrdersProvider> */}

        {
          user ?
            <Main />
            : <Login />
        }
        {/* </OrdersProvider> */}
      </Router>
    </QueryClientProvider>
  );
}

export default App;
